/* eslint-disable max-len */
const UserPlusIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="14.5402"
        cy="12.0001"
        rx="6.4"
        ry="6.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.94024 34.4001V31.2001C4.94024 27.6654 7.80562 24.8 11.3402 24.8H17.7402C21.2749 24.8 24.1402 27.6654 24.1402 31.2001V34.4001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7402 17.6501C25.326 17.6501 24.9902 17.9859 24.9902 18.4001C24.9902 18.8143 25.326 19.1501 25.7402 19.1501V17.6501ZM35.3402 19.1501C35.7545 19.1501 36.0902 18.8143 36.0902 18.4001C36.0902 17.9859 35.7545 17.6501 35.3402 17.6501V19.1501ZM31.2902 13.6001C31.2902 13.1859 30.9545 12.8501 30.5402 12.8501C30.126 12.8501 29.7902 13.1859 29.7902 13.6001H31.2902ZM29.7902 23.2001C29.7902 23.6143 30.126 23.9501 30.5402 23.9501C30.9545 23.9501 31.2902 23.6143 31.2902 23.2001H29.7902ZM25.7402 19.1501H35.3402V17.6501H25.7402V19.1501ZM29.7902 13.6001V23.2001H31.2902V13.6001H29.7902Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default UserPlusIcon;
